module.exports = __webpack_public_path__ + "static/media/subImg1.4b8ff9d8.png";